interface ValidAddressResponse {
    normalizedMacAddress: string;
    isValid: boolean;
}

export const normalizeAndValidateMacAddress = (macAddress: string): ValidAddressResponse => {
    // remove any non-alphanumeric characters and convert to lowercase
    const cleanInput = macAddress.replace(/[^a-zA-Z0-9]/g, "").toLowerCase();

    // mac addresses should be 12 characters long after cleaning
    if (cleanInput.length !== 12) {
        return { normalizedMacAddress: macAddress, isValid: false };
    }

    // check if all characters are valid hex
    if (!/^[0-9a-f]{12}$/.test(cleanInput)) {
        return { normalizedMacAddress: macAddress, isValid: false }
    }

    // format properly with colons added back (xx:xx:xx:xx:xx:xx)
    const normalizedMacAddress = cleanInput.match(/.{1,2}/g)?.join(":") || "";
    
    return { normalizedMacAddress, isValid: true }
}

export const isValidMacAddress = (macAddress: string): boolean => {
    const { isValid } = normalizeAndValidateMacAddress(macAddress);
    return isValid;
}
